import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreateBuilding from './CreateBuilding'
import ListBuildings from './ListBuildings'
import EditBuilding from './EditBuilding'

const Buildings = ({ match }) => (
  <div>
    <Route
      exact
      path={match.url}
      render={props => <ListBuildings {...props} />}
    />
    <Switch>
      <Route exact path={`${match.url}/add`} component={CreateBuilding} />
      <Route
        path={`${match.url}/:id`}
        render={props => <EditBuilding {...props} />}
      />
    </Switch>
  </div>
)

export default Buildings
